// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image_wrapper__9TiwR","title":"image_title__UuRaM","styledImage":"image_styledImage__lCj7s"};